module.exports = __webpack_public_path__ + "img/Philippines-4.a444ee0e.jpg";